<template>
  <img
    class="cross"
    :src="brandAsset(closeIcon, closeIconSanne)"
    @click="$emit('click')"
    alt="Leave"
  />
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import closeIcon from '@/assets/common/close-icon.svg';
import closeIconSanne from '@/assets/sanne/icons/close-icon.svg';

export default {
  name: 'LeaveButton',
  mixins: [brandMode],
  data: () => ({ closeIcon, closeIconSanne }),
};
</script>

<style lang="scss" scoped>
.cross {
  @apply absolute top-0 right-0 mx-5 cursor-pointer px-2;
  width: 32px;
  height: 32px;
  margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
  margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
  @screen md {
    @apply mt-12 mx-12 px-0;
    width: 28px;
    height: 28px;
  }
}
</style>
